import Flex from "../Flex/Flex.web";
import type { HighlightBoxSharedProps } from "./HighlightBox.props";

export default function HighlightBox(props: HighlightBoxProps): JSX.Element {
  const { statusColor, ...rest } = props;
  return (
    <Flex
      bg={`${statusColor}.200`}
      borderRadius="sm"
      w="100%"
      padding="xs"
      border="1px solid"
      borderColor={`${statusColor}.900`}
      color={`${statusColor}.800`}
      fontSize="xs"
      {...rest}
    />
  );
}

export type HighlightBoxProps = HighlightBoxSharedProps & {
  // Add any web specific props here.
};
